exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.prekickoff-wrapper[data-v-8963fc50] {\n  margin-top: 67px;\n  min-height: calc(100vh - 67px);\n  background: #f7f7f8;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.right-container[data-v-8963fc50] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.btn-wrap[data-v-8963fc50] {\n  padding-top: 9px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n", ""]);

// exports
